import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import store from '@/store'
import {StoreActionTypes} from '@/store/types'
import Auth from '../views/Auth.vue'
import Categories from '../views/category/list/Categories.vue'
import CategoryDetails from '../views/category/details/CategoryDetails.vue'
import Companies from '../views/company/list/Companies.vue'
import CompanyDetails from '@/views/company/details/CompanyDetails.vue'
import Criterion from '../views/Criterion.vue'
import Licenses from '../views/Licenses.vue'
import Dashboard from '../views/Dashboard.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Dashboard',
        component: Dashboard,
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: '/dashboard',
        redirect: '/'
    },
    {
        path: '/companies',
        name: 'Companies',
        component: Companies,
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: '/companies/:companyId',
        name: 'Company Details',
        component: CompanyDetails,
        props: true,
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: '/licenses',
        name: 'Licenses',
        component: Licenses,
        meta: { 
            requiresAuth: true
        }
    },    
    {
        path: '/categories',
        name: 'Categories',
        component: Categories,
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: '/categories/:categoryId',
        name: 'Category Details',
        component: CategoryDetails,
        props: true,
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: '/criterion',
        name: 'Criterion',
        component: Criterion,
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'Login Page',
        component: Auth,
        meta: { 
            requiresUnAuth: true
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (!store.getters.isAuthentificationAuthenticated) {
        store.dispatch(StoreActionTypes.CHECK_IS_LOGGED_IN)
    }

    if (to.meta.requiresAuth && !store.getters.isAuthentificationAuthenticated) {
        next('/login');
    }
    else if (to.meta.requiresUnAuth && store.getters.isAuthentificationAuthenticated) {
        next('/') 
    }
    else {
        next();
    }
})


export default router
